class RAMQLieuDeSuivi {
    public CodeGMF: number;
    public CodeLieu: number;
    public Date: string;
}

export { RAMQLieuDeSuivi };
